import { MonitoringPeriodCarbonInstance } from '../../types/apiModels'
import { apiClient } from './client'
import endpoints from './endpoints'
import type { ApiV2QueryType } from './types'
import { unwrapPaginated, type Paginated } from './normalize'

export default async function getBlockedMonitoringPeriods({
  query,
  farmId,
  signal,
}: {
  query?: ApiV2QueryType<MonitoringPeriodCarbonInstance>
  farmId: string
  signal?: AbortSignal
}): Promise<Paginated<MonitoringPeriodCarbonInstance>> {
  const response = await apiClient.get(endpoints.v2.farms.blockedMonitoringPeriods(farmId), {
    params: query,
    signal,
  })
  return unwrapPaginated<MonitoringPeriodCarbonInstance>(response)
}
